import { type Step } from "../../../components/Stepper/Stepper";
import {
  faBullhorn,
  faChartBar,
  faDice,
  faEnvelope,
  faGear,
  faGift,
  faPalette
} from "@fortawesome/free-solid-svg-icons";
import GiftIcon from "../../../components/Icons/Gift";
import DiceIcon from "../../../components/Icons/DiceIcon";
import CTAIcon from "../../../components/Icons/CTAIcon";
import MailIcon from "../../../components/Icons/MailIcon";
import BullHorn from "../../../components/Icons/BullHorn";
import Brush from "../../../components/Icons/Brush";
import { tt } from "../../../utils/i18n/i18n";
import Gear from "../../../components/Icons/Gear";

export const STEP_0 = -1;
export const STEP_1: number = 0;
export const STEP_2: number = 1;
export const STEP_3: number = 2;
export const STEP_4: number = 3;
export const STEP_5: number = 4;
export const STEP_6: number = 5;
export const STEP_7: number = 6;

export const baseSteps: Step[] = [
  {
    title: tt("onboarding_logo_and_colors_title"),
    name: tt("onboarding_logo_and_colors_name"),
    index: STEP_1,
    number: "1",
    icon: faPalette,
    svg: Brush(),
    pathName: "colors"
  },
  {
    title: tt("onboarding_choose_gifts_title"),
    name: tt("onboarding_choose_gifts_name"),
    index: STEP_2,
    number: "2",
    longTitle: tt("onboarding_choose_gifts_longtitle"),
    icon: faGift,
    svg: GiftIcon(),
    pathName: "prizes",
    videoURL: {
      fr: "https://www.youtube.com/embed/UNKcpxkVOY0",
      en: "https://www.youtube.com/embed/fFyJOvWhzLA"
    }
  },
  {
    title: tt("onboarding_select_games_title"),
    index: STEP_3,
    name: tt("onboarding_select_games_name"),
    number: "3",
    longTitle: tt("onboarding_select_games_longtitle"),
    icon: faDice,
    svg: DiceIcon(),
    pathName: "games",
    videoURL: {
      fr: "https://www.youtube.com/embed/BcqyvJ2vmpo",
      en: "https://www.youtube.com/embed/yBdUfYaVzkk"
    }
  },
  {
    title: tt("onboarding_choose_ctas_title"),
    index: STEP_4,
    name: tt("onboarding_choose_ctas_name"),
    number: "4",
    longTitle: tt("onboarding_choose_ctas_longtitle"),
    icon: faChartBar,
    svg: CTAIcon(),
    pathName: "ctas",
    videoURL: {
      fr: "https://www.youtube.com/embed/d81Yvc12IDg",
      en: "https://www.youtube.com/embed/8DFTShgdoug"
    }
  },
  {
    title: tt("onboarding_choose_emails_title"),
    index: STEP_5,
    name: tt("onboarding_choose_emails_name"),
    number: "5",
    longTitle: tt("onboarding_choose_emails_longtitle"),
    icon: faEnvelope,
    svg: MailIcon(),
    pathName: "marketing",
    videoURL: {
      fr: "https://www.youtube.com/embed/YA0e8FJh-NI",
      en: "https://www.youtube.com/embed/acsRQP2BnqQ"
    }
  },
  {
    title: tt("onboarding_choose_distribution_title"),
    index: STEP_6,
    name: tt("onboarding_choose_distribution_name"),
    number: "6",
    icon: faBullhorn,
    svg: BullHorn(),
    pathName: "distribution",
    videoURL: {
      fr: "https://www.youtube.com/embed/KUePYuqgVhs",
      en: "https://www.youtube.com/embed/xVnkh9t3dB8"
    }
  },
  {
    title: tt("onboarding_settings"),
    index: STEP_7,
    name: tt("onboarding_settings"),
    number: "7",
    icon: faGear,
    svg: Gear(),
    pathName: "settings"
  }
];
